import { post, get } from '../../common/ApiClient';
import { AddressPostResponse, Address, AddressGetResponse } from '../types/Address';
import { appendIfNotFalsy } from '../../utils/appendFormData';

export const getAddresses = async (email: string) => {
  try {
    const { data } = await get<AddressGetResponse>('/users/addresses', false, undefined, {
      email: email,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const updateAddress = async (address: Address): Promise<AddressPostResponse | undefined> => {
  try {
    let formData = new FormData();

    formData.append('email', address.email);
    formData.append('type', address.type);

    appendIfNotFalsy(formData, 'company_name', address.companyName);
    appendIfNotFalsy(formData, 'first_name', address.firstName);
    appendIfNotFalsy(formData, 'last_name', address.lastName);
    appendIfNotFalsy(formData, 'address', address.address);
    appendIfNotFalsy(formData, 'number', address.number);
    appendIfNotFalsy(formData, 'zip', address.zip);
    appendIfNotFalsy(formData, 'city', address.city);
    appendIfNotFalsy(formData, 'phone_number', address.phoneNumber);
    appendIfNotFalsy(formData, 'country_iso', address.countryIso);
    appendIfNotFalsy(formData, 'company_id', address.companyId);
    appendIfNotFalsy(formData, 'company_tax_id', address.taxId);
    appendIfNotFalsy(formData, 'company_vat_id', address.vatId);

    const { data } = await post<AddressPostResponse>('/users/update-address/', true, formData);

    return data;
  } catch (error) {
    throw error;
  } finally {
  }
};

export const addNewAddress = async (address: Address): Promise<AddressPostResponse> => {
  try {
    let formData = new FormData();

    formData.append('email', address.email);
    formData.append('type', address.type);

    appendIfNotFalsy(formData, 'first_name', address.firstName);
    appendIfNotFalsy(formData, 'last_name', address.lastName);
    appendIfNotFalsy(formData, 'company_name', address.companyName);
    appendIfNotFalsy(formData, 'address', address.address);
    appendIfNotFalsy(formData, 'number', address.number);
    appendIfNotFalsy(formData, 'zip', address.zip);
    appendIfNotFalsy(formData, 'city', address.city);
    appendIfNotFalsy(formData, 'phone_number', address.phoneNumber);
    appendIfNotFalsy(formData, 'country_iso', address.countryIso);
    appendIfNotFalsy(formData, 'company_id', address.companyId);
    appendIfNotFalsy(formData, 'tax_id', address.taxId);
    appendIfNotFalsy(formData, 'vat_id', address.vatId);

    const { data } = await post<AddressPostResponse>('/users/address', false, formData);

    return data;
  } catch (error) {
    throw error;
  }
};
